//const SITE_URL = 'http://localhost:8080/';
const SITE_URL = 'https://decojovem.pt/';
export default URL = {
	app			: `${SITE_URL}`,
	temas 		: `${SITE_URL}wp-json/wp/v2/temas_mundo_on`,
	mundo_on 	: ` ${SITE_URL}wp-json/wp/v2/mundo_on`,
	ajax 		: `${SITE_URL}blog/wp-admin/admin-ajax.php`,
	likes_cb 	: '?action=update_likes',
	neutral_cb 	: '?action=update_neutral',
	negative_cb : '?action=update_negative',
	menus 		: `${SITE_URL}wp-json/wp-api-menus/v2/menus/401`,
	menuFooter 	: `${SITE_URL}wp-json/wp-api-menus/v2/menus/404`,
	pages 		: `${SITE_URL}wp-json/wp/v2/pages_mundo_on/`
}


// WEBPACK FOOTER //
// ./src/flux/path.js